import gql from "graphql-tag";

import { PrepaidBalancePartsFragmentDoc } from "icons/fragments";

export const GET_SAVED_CARD = gql`
    query savedCard($organizationId: ID) {
        savedCard(organizationId: $organizationId) {
            id
            receiptInfo
        }
    }
`;

export const GET_CURRENT_USER_WITH_BILLING = gql`
    query currentUser {
        currentUser {
            id
            username
            email
            hasSubscription
            ...PrepaidBalanceParts
            ownedTeams {
                username
                name
            }
        }
    }
    ${PrepaidBalancePartsFragmentDoc}
`;

export const GET_SUBSCRIPTION = gql`
    query($username: String) {
        getSubscription(username: $username) {
            stripeId
            paypalId
            plan {
                name
            }
            status
        }
    }
`;
